import { render, staticRenderFns } from "./RelatorioGestaoPcaBoc.vue?vue&type=template&id=7669cca8"
import script from "./RelatorioGestaoPcaBoc.vue?vue&type=script&lang=ts"
export * from "./RelatorioGestaoPcaBoc.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports